import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './LegendContent.module.css';
import { withTranslation } from '../../../Translator';
import Checkbox from '../../../Checkbox';
import { RadioWidget } from '../../../RadioButtonGroup/components/RadioWidget';

const bindClasses = classNameBind.bind(styles);

/* eslint-disable react/no-array-index-key */

const LegendContent = ({
  payload,
  framed,
  chartType,
  labelSeries,
  labelSegment = null,
  compareMode,
  compareDivider,
  maxHeight,
  clickableLegendProps = {},
  t,
} = {}) => {
  const isPie = chartType === 'pie';
  const { selected = [], enabled, onSelect = () => {}, series, single } = clickableLegendProps;
  let clickableLegend;

  const classicLegend = payload.map((entry, index) => ([
    compareDivider > 0
    && (index % compareDivider) === 0
    && compareMode.length > (index / compareDivider)
      ? (
        <div className={bindClasses('segment-label', `lvl-${index / compareDivider}`)} key={index}>{compareMode[index / compareDivider]}</div>
      ) : null,
    <div className={bindClasses('legend-entry')} key={`item-${index}`}>
      <div className={bindClasses('legend-icon')} style={{ backgroundColor: entry.payload?.color || entry.color }} />
      <div className={bindClasses('legend-label')}>{entry.value}</div>
    </div>,
  ]));

  const getColorFromEntry = (option) => {
    const entry = payload.find(ent => ent.dataKey === option.id) || {};

    return entry.payload?.color || entry.color;
  };

  if (enabled) {
    let seriesWithSegments = series.map(el => ({ ...el, setId: el.id }));

    if (compareMode.length && !single) {
      for (let i = 1; i < compareMode.length; i++) {
        seriesWithSegments = [...seriesWithSegments, ...series.map(el => ({ ...el, id: el[`id${i}`], setId: el.id }))];
      }
    }

    clickableLegend = (
      single && compareMode.length
        ? (
          <>
            {compareMode.map((mode, i) => (
              <>
                {!!i && <div className={bindClasses('vs')}>{t('vs')}</div>}
                <div className={bindClasses('segment-label', `lvl-${i}`, 'spacing-8')} key={i}>{mode}</div>
              </>
            ))}
            <div className={bindClasses('radio-section')}>
              {
                seriesWithSegments.map((option, index) => ([
                  <div className={bindClasses('legend-entry')} key={`item-${index}`}>
                    <div className={bindClasses('legend-radio')}>
                      <RadioWidget
                        id={option.id}
                        value={option.id}
                        selected={selected.includes(option.setId)}
                        onClick={() => {
                          onSelect(option.setId, true);
                        }}
                        dataId={`Chart.Legend.Radio_${option.id}`}
                      />
                    </div>
                    <div
                      className={bindClasses('legend-label')}
                      onClick={() => {
                        onSelect(option.setId, true);
                      }}
                      role="radio"
                      tabIndex={0}
                      aria-checked={selected.includes(option.setId)}
                    >
                      {option.name}
                    </div>
                  </div>,
                ]))
              }
            </div>
          </>
        )
        : (
          <div className={bindClasses('checkbox-section')}>
            {
              seriesWithSegments.map((option, index) => ([
                series.length
                && (index % series.length) === 0
                && compareMode.length > (index / series.length)
                  ? (
                    <div className={bindClasses('segment-label', `lvl-${index / series.length}`, 'spacing-16')} key={index}>{compareMode[index / series.length]}</div>
                  ) : null,
                <div className={bindClasses('legend-entry')} key={`item-${index}`}>
                  <div className={bindClasses('legend-checkbox')}>
                    <Checkbox
                      name={`checkbox_${option.id}`}
                      id={`checkbox_${option.id}`}
                      dataId={`Chart.Legend.Checkbox_${option.id}`}
                      checked={selected.includes(option.setId)}
                      onChange={({ target: { checked } }) => {
                        onSelect(option.setId, checked);
                      }}
                      customCheckedColor={getColorFromEntry(option)}
                    />
                  </div>
                  <div
                    className={bindClasses('legend-label')}
                    onClick={() => {
                      onSelect(option.setId, !selected.includes(option.setId));
                    }}
                    role="checkbox"
                    tabIndex={0}
                    aria-checked={selected.includes(option.setId)}
                  >
                    {option.name}
                  </div>
                </div>,
              ]))
            }
          </div>
        )
    );
  }

  return (
    <div
      className={bindClasses('legend-wrapper', { framed, clickable: clickableLegendProps.enabled }, chartType)}
      style={maxHeight ? { maxHeight } : null}
      data-ppuc-id="Chart.LegendContent"
    >
      {
        labelSeries ? (
          <div className={bindClasses('legend-series', { isPie, 'spacing-16': clickableLegendProps.enabled })}>
            {labelSeries}
            {!isPie && ':'}
          </div>
        ) : null
      }
      {labelSegment !== null && (
        <div>
          <div className={bindClasses('segment-label', `lvl-${labelSegment.id}`)}>
            {labelSegment.name}
          </div>
        </div>
      )}
      { clickableLegend || classicLegend }
    </div>
  );
};

LegendContent.defaultProps = {
  chartType: '',
  compareDivider: 0,
  compareMode: [],
  labelSegment: null,
  maxHeight: null,
  clickableLegendProps: {},
};

export default withTranslation('components')(LegendContent);
